import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/l-h-logo.svg")